import StatusDataContext from '@/contexts/status-data-context';
import { useContext } from 'react';

export const useStatusData = () => {
  return useContext(StatusDataContext);
};
